<template>
  <v-app>
    <v-container class="text-center">
      <router-view /> 
    </v-container>
  </v-app>
</template>
<script>
export default {
  
}
</script>